import { popoverFiltroPedidoMktStyles } from './PopoverFiltroPedidoMkt.styles'

export function popoverFiltroPedidoMktIO() {
  return {
    styles: popoverFiltroPedidoMktStyles
  }
}

export type PopoverFiltroPedidoMktIO = ReturnType<typeof popoverFiltroPedidoMktIO>
